import { CollectionController } from 'controller/collection'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { IEventCollectionDataActiveEvents, IEventCollectionMetadata } from 'meta/pages/v4/eventCollection'
import { RootState } from 'store/types'

type Params = {
  collectionId: string
  page: number
}

type Returned = {
  data: IEventCollectionDataActiveEvents,
  metadata: IEventCollectionMetadata,
  collectionId: string
}

export const getActiveEvents = createAsyncThunk<Returned, Params, { state: RootState }>(
  'collection/getActiveEvents',
  async (params) => {
    const { collectionId, page } = params

    const { data, metadata } = await CollectionController.getActiveEvents({ collectionId, page })

    return { data, metadata, collectionId }
  }
)
